import { DecimalPipe, NgFor, NgIf, NgOptimizedImage, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Brand, Product, Professionist } from 'src/app/api';
import { AppComponent } from 'src/app/app.component';
import { ConsoleLoggerService } from 'src/app/services/console-logger.service';

@Component({
  selector: 'app-card-professionista',
  templateUrl: './card-professionista.component.html',
  styleUrls: ['./card-professionista.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, DecimalPipe, TitleCasePipe, NgOptimizedImage]
})
export class CardProfessionistaComponent implements OnInit {
  @Input() professionistObj: Professionist;
  @Input() brandObj: Brand;
  @Input() isDetailBrandPage: boolean;
  @Output() openPopup = new EventEmitter();

  constructor(
    public main: AppComponent,
    private console: ConsoleLoggerService
  ) { }

  ngOnInit(): void { }

  generateUrl(): string {
    return `/consulente-credito-mutui-prestiti-assicurazioni/${this.professionistObj?.slug}`;
  }

  // GESTIONE PREFERITI
  async handleFavouriteProfessionist(): Promise<number | void> {
    if (this.main?.isLogged) {
      const result = await this.main?.savedProfessionistListing(this.professionistObj);
      this.professionistObj.numberOfFavourites += result;
    } else {
      this.openPopup.emit();
    }
  }

  // GESTIONE LIKE
  async handleLikesProfessionist(): Promise<number | void> {
    if (this.main?.isLogged) {
      const result = await this.main?.likedProfessionistEvt(this.professionistObj);
      this.professionistObj.likes += result;
    } else {
      this.openPopup.emit();
    }
  }

  // handleProfessionistRole(role: string): any {
  //   if (role?.toLowerCase() === 'consulente') {
  //     return 'Consulente'
  //   } else if (role?.toLowerCase() === 'consulente junior') {
  //     return 'Consulente Junior';
  //   }
  //   return role;
  // }

  // CALCOLA TIPOLOGIA PRODOTTI
  showProductFilter(index): Product[] {
    try {
      let productList = [...this.professionistObj.products, ...this.professionistObj.branded_products];
      if (index === 2) {
        productList = productList.filter((prod) => prod.type === 'assicurativo');
      } else if (index === 1) {
        productList = productList.filter((prod) => prod.type === 'finanziario');
      }

      return productList;
    } catch (error) {
      return [];
    }
  }
}
